import { ReactNode } from "react";
import styled from "styled-components";
import { Flex } from "../Box/Box";
import { Icon } from "../Icon/Icon";
import { Tooltip } from "src/components";
import { Color } from "../Color/Color";

const Trigger = styled(Flex)`
  border-radius: 2px;

  &:focus-visible {
    outline: 2px solid ${Color.primary};
    outline-offset: 2px;
  }
`;

interface Props {
  tooltip: string | ReactNode;
  accessibleLabel?: string;
  width?: string;
}

export const InfoTooltip = ({ tooltip, accessibleLabel, width }: Props) => {
  const isAccessibleTrigger = accessibleLabel !== undefined;
  return (
    <Trigger
      padding="0 3px"
      role={isAccessibleTrigger ? "button" : undefined}
      tabIndex={isAccessibleTrigger ? 0 : undefined}
      aria-label={accessibleLabel}
      cursor="default"
    >
      <Icon name="info" size={12} color={Color.spaceGray} />
      {typeof tooltip === "string" ? (
        <Tooltip isUsingFocus={isAccessibleTrigger} width={width}>
          {tooltip}
        </Tooltip>
      ) : (
        tooltip
      )}
    </Trigger>
  );
};
